const deDe = require('./lang/de-DE.json');
const enUs = require('./lang/en-US.json');
const enGb = require('./lang/en-GB.json');
const frFr = require('./lang/fr-FR.json');

// Map of browser langCode to file of localized strings
const languages = {
  "de": deDe,
  "de-DE": deDe,
  "en-US": enUs,
  "en-GB": enGb,
  "fr": frFr,
  "fr-FR": frFr
};

// Map of locale code to a key in languages
const locales = {
  "us": "en-US",
  "usa": "en-US",
  "dk": "da-DK",
  "dnk": "da-DK",
  "de": "de-DE",
  "deu": "de-DE",
  "mx": "es-MX",
  "es": "es-ES",
  "esp": "es-ES",
  "fr": "fr-FR",
  "fra": "fr-FR",
  "it": "it-IT",
  "ita": "it-IT",
  "hu": "hu-HU",
  "hun": "hu-HU",
  "nl": "nl-NL",
  "nld": "nl-NL",
  "no": "nn-NO",
  "nor": "nn-NO",
  "nob": "nb-NO",
  "pl": "pl-PL",
  "pol": "pl-PL",
  "br": "pt-BR",
  "bra": "pt-BR",
  "pt": "pt-PT",
  "prt": "pt-PT",
  "por": "pt-PT",
  "ro": "ro-RO",
  "rou": "ro-RO",
  "sk": "sk-SK",
  "svk": "sk-SK",
  "fi": "fi-FI",
  "fin": "fi-FI",
  "se": "sv-SE",
  "swe": "sv-SE",
  "tr": "tr-TR",
  "tur": "tr-TR",
  "cz": "cs-CZ",
  "cze": "cs-CZ",
  "gr": "el-GR",
  "grc": "el-GR",
  "ru": "ru-RU",
  "rus": "ru-RU",
  "jp": "ja-JP",
  "jpn": "ja-JP",
  "cn": "zh-CN",
  "chn": "zh-CN",
  "hans": "zh-CN",
  "sgp": "zh-CN",
  "tw": "zh-TW",
  "twn": "zh-TW",
  "hant": "zh-TW",
  "hkg": "zh-TW",
  "kr": "ko-KR",
  "kor": "ko-KR",
  "il": "he-IL",
  "heb": "he-IL",
  "sa": "ar-SA",
  "ara": "ar-SA"
};

// angular library browser language detection
function getBrowserLanguage() {
  let nav = window.navigator;
  let browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
  let language = null;

  // support for HTML 5.1 "navigator.languages"
  if (Array.isArray(nav.languages)) {
    for (let i = 0; i < nav.languages.length; i++) {
      language = nav.languages[i];
      if (language && language.length) {
        return language;
      }
    }
  }

  // support for other well known properties in browsers
  for (let i = 0; i < browserLanguagePropertyKeys.length; i++) {
    language = nav[browserLanguagePropertyKeys[i]];
    if (language && language.length) {
      return language;
    }
  }
  return null;
}

/**
 * Maps dispLang and dispLocale from CCT app to a langCode in
 * languages map.  Defaults langCode to en-US.
 * @param dispLang
 * @param dispLocale
 */
export function getLangCodeFromLocale(dispLocale) {
  return locales[dispLocale] || 'en-US';
}

export function setLangCode(langCode) {
  if (langCode) {
    sessionStorage.setItem('langCode', langCode);
  }
}

export function getLangCode() {
  let langCode = sessionStorage.getItem('langCode');
  if (!langCode) {
    langCode = getBrowserLanguage().trim(); // fallback to browser language
  }

  // TODO: fallback to language by ip
  if (!langCode) {
    langCode = 'en-US'; // default
  }
  return langCode;
}

export function stringBundle(/* optional */ langCode) {
  if (languages.hasOwnProperty(langCode)) {
    return languages[langCode];
  }
  return languages["en-US"];
}




// WEBPACK FOOTER //
// ./src/stringBundle.js